import { useGeneral } from './Context/GeneralContext';

// Punto único de gating para la edición de capacidades y elegibilidad de productos.
// Hoy el frontend solo distingue 'Administrador' vs 'Consulta' (isConsulta).
// TODO: cuando el backend exponga roles granulares en el token, migrar a
// infoUser.EsAdmin || infoUser.EsPlaneacion. El backend ya restringe la escritura
// a EsAdmin/EsPlaneacion/EsDesarrollador, así que esto es solo el gate de UI.
export function useCanEditCapacidades() {
    const { isConsulta } = useGeneral();
    return !isConsulta;
}
